import React from "react";
import { useAssessmentState } from "../../../../services/assessment-state";
import { AssessmentState } from "../../../../services/assessment-state/types";
import { TextButton, TextButtonGroup } from "../shared/TextButton";
import { AssessmentCopy } from "../utils";

export const WhoFor: React.FC = () => {
    const { state, setState, getNextScreenIndex } = useAssessmentState();

    return (
        <TextButtonGroup title={AssessmentCopy.WHO_FOR}>
            <TextButton
                isActive={state.target === "MYSELF"}
                onClick={() => {
                    setState({
                        target: "MYSELF",
                        currentScreen: getNextScreenIndex(),
                    });
                }}
            >
                Myself
            </TextButton>
            <TextButton
                isActive={state.target === "SOMEONE_ELSE"}
                onClick={() => {
                    setState({
                        target: "SOMEONE_ELSE",
                        currentScreen: getNextScreenIndex(),
                    });
                }}
            >
                Someone else
            </TextButton>
        </TextButtonGroup>
    );
};

export const createMeta = (state: AssessmentState) => ({
    title: "Who is the support for?",
    canProgress: state.target !== undefined,
    canSkip: true,
});
